import { useTranslation } from 'react-i18next';

export default function CTA() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20product%20flat%20lay%20of%20diverse%20fashion%20items%20including%20colorful%20sneakers%2C%20a%20folded%20hoodie%2C%20accessories%2C%20and%20a%20wristwatch%20scattered%20on%20a%20soft%20warm%20sand%20textured%20surface%2C%20wide%20panoramic%20composition%2C%20golden%20hour%20natural%20light%2C%20luxury%20lifestyle%20catalog%20style%2C%20warm%20rich%20tones&width=1920&height=800&seq=kakobuy-cta-bg-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet produkty"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/80 via-foreground-900/60 to-foreground-900/40"></div>
      </div>

      <div className="relative z-10 px-4 md:px-6 lg:px-10 max-w-[800px] mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          {t('cta.title')}
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-lg mx-auto">
          {t('cta.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-accent-500 text-background-50 font-medium text-sm md:text-base whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
          >
            <i className="ri-external-link-line"></i>
            {t('cta.button')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full border-2 border-background-50/60 text-background-50 font-medium text-sm md:text-base whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
          >
            {t('cta.buy_button')}
          </a>
        </div>
      </div>
    </section>
  );
}